import styled from 'styled-components';
import media from '../../../themes/media';

const Layout = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: #001947;

  ${media.greaterThan('desktop')`
    background: #001947;
    flex-direction: row;
    padding-top: 0;
  `}
`;

const Content = styled.div`
  display: flex;
  scroll-behavior: smooth;
  background: ${(props) =>
    props.theme.colors.background.secondaryColor || '#fbfbfb'};
  border-radius: 30px 0 0 30px;
  padding: 20px 0 0;
  width: 100%;
  flex-grow: 1;
  position: relative;

  ${media.lessThan('desktop')`
    background: transparent;
    border-radius: 0;
    padding: 0;
  `}

  > * {
    flex-grow: 1;
  }
`;

export { Layout, Content };
